import React, { useId, useState } from 'react';
import './PasswordChangeModal.css';
import { PASSWORD_HELP_TEXT, validatePassword } from '../utils/passwordPolicy';

function PasswordChangeModal({ userId, onClose, onPasswordChange }) {
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [saving, setSaving] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const id = useId();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (saving) return;
    setError('');
    if (newPassword !== confirmPassword) {
      setError('Lozinke se ne podudaraju');
      return;
    }
    const passwordPolicyError = validatePassword(newPassword);
    if (passwordPolicyError) {
      setError(passwordPolicyError);
      return;
    }
    setSaving(true);
    try {
      await onPasswordChange(userId, newPassword);
    } catch (err) {
      setError(err.message || 'Greška pri promjeni lozinke. Pokušajte ponovo.');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content password-change-modal" role="dialog" aria-modal="true" aria-labelledby="password-change-title">
        <h3 id="password-change-title">Promjena lozinke</h3>
        {error && <div className="error-message" role="alert">{error}</div>}
        <form onSubmit={handleSubmit} noValidate>
          <div className="form-group">
            <label htmlFor={`${id}-new`}>Nova lozinka:</label>
            <input
              id={`${id}-new`}
              type={showPassword ? 'text' : 'password'}
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              autoComplete="new-password"
              required
            />
            <small className="password-help">{PASSWORD_HELP_TEXT}</small>
          </div>
          <div className="form-group">
            <label htmlFor={`${id}-confirm`}>Potvrdi lozinku:</label>
            <input
              id={`${id}-confirm`}
              type={showPassword ? 'text' : 'password'}
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              autoComplete="new-password"
              required
            />
          </div>
          <label className="password-visibility">
            <input type="checkbox" checked={showPassword} onChange={event => setShowPassword(event.target.checked)} />
            <span>Prikaži unesene lozinke</span>
          </label>
          <div className="modal-actions">
            <button type="submit" className="save-btn" disabled={saving}>{saving ? 'Spremanje…' : 'Spremi'}</button>
            <button type="button" className="cancel-btn" disabled={saving} onClick={onClose}>Odustani</button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default PasswordChangeModal;
